import request from './request'

export function getAd() {
  const url = '/user/coupon_diag'
  return request.get(url, {
    params: {
    }
  })
}
export function getCoupon(ids) {
  const url = '/user/get_coupon'
  return request.get(url, {
    params: {
      coupon_ids: ids
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/ad-popup.js